import { useTranslation } from 'react-i18next';

import { PaymentSettings } from '../usePaymentSettings';

export const usePaymentDisclaimer = () => {
  const { t } = useTranslation();

  const generateDisclaimerText = (settings: PaymentSettings) => {
    if (settings.requiresPrepayment) {
      return t('components.checkoutFormPopup.paymentDisclaimer.shopRequiresFullPayment');
    }

    if (settings.requiresPartialDeposits) {
      if (settings.depositType === 'percentage' && settings.depositPercentage) {
        return t('components.checkoutFormPopup.paymentDisclaimer.bookingRequiresPercentageDeposit', {
          percent: settings.depositPercentage,
        });
      }
      if (settings.depositType === 'amount' && settings.depositAmount) {
        return t('components.checkoutFormPopup.paymentDisclaimer.bookingRequiresAmountDeposit', {
          amount: (settings.depositAmount / 100).toFixed(2),
        });
      }
      return t('components.checkoutFormPopup.paymentDisclaimer.bookingRequiresDeposit');
    }

    if (settings.allowInPersonPayments && settings.requestCardForInPersonPayments) {
      return t('components.checkoutFormPopup.paymentDisclaimer.shopRequiresCardOnFile');
    }

    if (settings.allowInPersonPayments && !settings.requestCardForInPersonPayments) {
      return t('components.checkoutFormPopup.paymentDisclaimer.shopAllowsInPersonPayments');
    }

    return null;
  };

  return {
    generateDisclaimerText,
  };
};
